// 2026-09-17：管理列表缩略仅影响显示，保留全文、订单复制值及审计日志原始内容。
export function shortProductName(value: unknown): string {
  // 2026-09-17：取消固定字数截断，所有调用保留原文，展示长度由响应式单元格决定。
  return String(value ?? '')
}

export function compactColumnWidth(column: { dataIndex?: string; width?: number }): number {
  if (['title', 'productName'].includes(column.dataIndex || '')) return 144
  if (column.dataIndex === 'orderNumber') return 198
  if (column.dataIndex === 'orderInfo') return 290
  if (['command', 'subcommand', 'operate', 'refound'].includes(column.dataIndex || '')) return column.width || 180
  return column.width ? Math.min(column.width, 240) : 112
}

export async function copyFullOrderNumber(value: unknown): Promise<void> {
  const text = String(value ?? '')
  if (!text) throw new Error('订单号为空')
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return
    }
  } catch (_) { /* 浏览器未授权剪贴板时使用当前用户点击触发的兼容方式。 */ }
  const active = document.activeElement as HTMLElement | null
  const input = document.createElement('textarea')
  input.value = text
  input.readOnly = true
  input.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0'
  document.body.appendChild(input)
  try {
    input.select()
    if (!document.execCommand('copy')) throw new Error('复制失败，请手动复制订单号')
  } finally {
    input.remove()
    active?.focus()
  }
}

export function fullOperationEvent(value: unknown): string {
  return String(value ?? '').replace(/^msg\.route\./, '')
}

export function shortOperationEvent(value: unknown): string {
  const full = fullOperationEvent(value)
  const parts = full.split(/[｜|]/).map(part => part.trim()).filter(Boolean)
  if (parts.length < 2) return full
  const field = (name: string) => parts.find(part => part.startsWith(name + '='))?.slice(name.length + 1) || ''
  const action = parts[1]
  // 2026-10-01：平台售卖审核摘要保留款号、名称和来源门店，明细标识仍在悬停全文中。
  if (parts[0] === '上平台售卖审核') {
    const identity = field('款号') ? `款号：${field('款号')}` : field('平台编号') ? `平台编号：${field('平台编号')}` : field('商品ID') ? `商品ID：${field('商品ID')}` : ''
    const details = [identity, field('名称'), field('来源门店') ? `门店：${field('来源门店')}` : field('来源机构ID') ? `门店ID：${field('来源机构ID')}` : '', field('颜色'), field('尺码')].filter(Boolean)
    return `${parts[0]}：${action}${details.length ? '；' + details.join(' / ') : ''}`
  }
  if (parts[0] === '商品删除') {
    const type = field('类型') || '商品'
    const code = field('编码') || field('款号') || field('名称') || field('商品ID')
    return `商品${type === '商品' ? '' : type}-${action}${code ? ' ' + code : ''}`
  }
  if (parts[0] === 'VIP角色总控' && ['客户类型功能池', 'VIP角色功能'].includes(action)) {
    const change = field('修改后').startsWith('已启用') ? '启用' : field('修改后').startsWith('已移除') ? '移除' : '修改'
    return `VIP角色总控-${change}${field('角色') || field('客户类型')}的${field('功能') || action}`
  }
  const roleName = parts[0] === 'VIP角色总控' && /[新增修改删除]VIP角色/.test(action) ? field('修改后').split('(')[0] : ''
  const subject = field('角色名称') || field('角色') || field('机构') || field('客户') || field('名称') || roleName || field('角色ID')
  return parts[0] + '-' + action + (subject ? ' ' + subject : '')
}
